const indexItems = [
  { title: '恋爱韩漫', count: '856部', desc: '甜蜜校园、办公室恋情、契约婚姻' },
  { title: '奇幻韩漫', count: '623部', desc: '异世界转生、魔法冒险、剑与魔法' },
  { title: '动作韩漫', count: '412部', desc: '热血格斗、超能力对决、江湖武侠' },
  { title: '悬疑韩漫', count: '287部', desc: '犯罪推理、心理惊悚、反转剧情' },
  { title: '日常韩漫', count: '398部', desc: '治愈生活、美食日常、温馨故事' },
  { title: '古风韩漫', count: '176部', desc: '宫廷权谋、古装恋情、历史传奇' },
  { title: '搞笑韩漫', count: '345部', desc: '校园喜剧、沙雕日常、爆笑短篇' },
  { title: '恐怖韩漫', count: '134部', desc: '灵异惊悚、都市怪谈、心理恐怖' },
];

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-3">
          主题索引
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          按题材快速浏览，找到你最爱的韩漫类型
        </p>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {indexItems.map((item, i) => (
            <a
              key={i}
              href="#cards"
              className="group flex flex-col items-center text-center bg-background-100 rounded-lg p-5 md:p-6 border border-background-200/70 transition-all duration-300 hover:border-primary-200 hover:bg-background-50 cursor-pointer"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-3 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
                <i className={`${
                  ['ri-heart-line', 'ri-magic-line', 'ri-sword-line', 'ri-search-eye-line', 'ri-sun-line', 'ri-building-line', 'ri-emotion-laugh-line', 'ri-ghost-line'][i]
                } text-2xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 group-hover:text-primary-500 transition-colors mb-1">
                {item.title}
              </h3>
              <span className="text-xs text-primary-500 font-medium mb-2">{item.count}</span>
              <p className="text-xs text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}